import { render } from "./sipNumber.vue?vue&type=template&id=1826405e&scoped=true"
import script from "./sipNumber.vue?vue&type=script&lang=js"
export * from "./sipNumber.vue?vue&type=script&lang=js"

import "./sipNumber.vue?vue&type=style&index=0&id=1826405e&scoped=true&lang=css"
import "./sipNumber.vue?vue&type=style&index=1&id=1826405e&lang=css"
script.render = render
script.__scopeId = "data-v-1826405e"

export default script